export default "__VITE_ASSET__CBIU4UuJ__"